import {connect} from "react-redux";
import { actions as businessCardActions , selectors as businessCardSelectors } from '../../BusinessCard';
import { actions as imageActions } from '../../Image';
import CardSettingsPanel from './CardSettingsPanel';

const { editCardSetting } = businessCardActions;
const { getCardActions , getCardSettings } = businessCardSelectors;
const { updateBackgroundImage , updateHeaderImage , updateAvatarImage } = imageActions;


const mapDispatchToProps = (dispatch) => {
    return {
    // removeCardAction: actionToRemoveName => dispatch(removeCardAction(actionToRemoveName)),
    // removeAction: (actionToRemoveId,position) => dispatch(removeCardAction(actionToRemoveId,position)),
    // addCardAction: actionToAdd => dispatch(addCardAction(actionToAdd)),
    // updateAction: updatedAction => dispatch(updateCardAction(updatedAction)),
    // getCardAction: actionName => dispatch(getCardAction(actionName)),
    // setCardActions: (actions) => dispatch(setActions(actions)),
    updateAvatar: (imageFile) => dispatch(updateAvatarImage(imageFile)),
    updateBackgroundImage: (imageFile) => dispatch(updateBackgroundImage(imageFile)),
    updateHeaderImage: (imageFile) => dispatch(updateHeaderImage(imageFile)),
    editCardSetting: (level,setting,value) => dispatch(editCardSetting(level,setting,value))
    };
};


const mapStateToProps = (state) => {
    return {
        cardSettings: getCardSettings(state),
        actions: getCardActions(state),//TODO: change this according to the new state structure
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(CardSettingsPanel);